import styled from "styled-components";
import { colors } from "@util/constants"

export const HeaderNavMobileWrapper = styled.div<{
  active: boolean;
}>`
  position:fixed;
  z-index:30;
  padding:15px;
  background-color:${colors.white};
  left:0;
  height:100%;
  width:100% ;
  overflow-y:auto;
  overflow-x:hidden;
  top:250%;
  transition: top .25s;
  ${({ active }) => active && `top: 0;`}
  .inner{
    color:${colors.primary};
  }
  .intro{
    margin-bottom:25px;
    .top-wrapper{
      min-height:47px;
      display:flex;
      justify-content:flex-end;
      align-items:center;
      margin-bottom:25px;
      .icon-close-circle{
        position:fixed;
        left:15px;
        z-index: 5;
      }
    }
    .search-field{
      max-width:100%;
    }
  }
  .icon-close-circle{
    color:${colors.white};
  }
  nav{
    color:${colors.primary};
    position:relative;
    > li{
      &:not(:last-child){
        margin-bottom:15px;
      }
    }
  }
  .mob-card-button{
    height: 112px;
    width:100%;
    padding-left:35px;
    padding-right:35px;
    font-size:20px;
    display:flex;
    justify-content: space-between;
    align-items: center;
    background-color: ${colors.lightGrey};
    border-radius:5px ;
    font-weight:bold;
    cursor:pointer;
    svg{
      width: 16px;
      height: auto;
      transform: rotate(-90deg);
    }
  }
  .mob-card-button--no-dropdown{
    div{
      display:flex;
      align-items: center;
    }
  }
`

export const NavLevelTwoItemsWrapper = styled.div<{
  status: boolean;
}>`
  background-color:white;
  width:100%;
  height:100%;
  transition: transform .25s;
  position:absolute;
  left:0;
  top:0;
  z-index:1 ;
  ${({ status }) => status ? `
    transform: translateX(0);
  ` : `
    transform: translateX(150%);
  `} 

  .mob-card-button{
    margin-bottom:40px;
    flex-direction: row-reverse;
    justify-content: start;
    span{
      margin-left:26px;
    }
    svg{
      transform: rotate(90deg);
    }
  }

  ul{
    padding-left:7.5px;
    padding-right:7.5px;
    li{
      a{
        padding:20px 0;
        border-bottom:1px solid ${colors.lightGrey};
        display:block;
      }
      &:first-child{
        a{padding-top:0;}
      }
      &:last-child{
        a{
          padding-bottom:0;
          border-bottom:none;
        }
      }
    }
  }
`

export const CardButton = styled.div`

`